export default Object.freeze({
  UPLOAD: 'UPLOAD',
  DUPLICATE_STATE_UPDATE: 'DUPLICATE_STATE_UPDATE',
  SCREENING_VOTE_CREATE: 'SCREENING_VOTE_CREATE',
  SCREENING_VOTE_UPDATE: 'SCREENING_VOTE_UPDATE',
  SCREENING_VOTE_CONFLICT: 'SCREENING_VOTE_CONFLICT',
  SCREENING_VOTE_REVOKE: 'SCREENING_VOTE_REVOKE',
  SCREENING_OUTCOME_CREATE: 'SCREENING_OUTCOME_CREATE',
  SCREENING_OUTCOME_UPDATE: 'SCREENING_OUTCOME_UPDATE',
  SCREENING_OUTCOME_REVOKE: 'SCREENING_OUTCOME_REVOKE',
  FULL_TEXT_REVIEW_VOTE_CREATE: 'FULL_TEXT_REVIEW_VOTE_CREATE',
  FULL_TEXT_REVIEW_VOTE_UPDATE: 'FULL_TEXT_REVIEW_VOTE_UPDATE',
  FULL_TEXT_REVIEW_VOTE_CONFLICT: 'FULL_TEXT_REVIEW_VOTE_CONFLICT',
  FULL_TEXT_REVIEW_VOTE_REVOKE: 'FULL_TEXT_REVIEW_VOTE_REVOKE',
  FULL_TEXT_REVIEW_OUTCOME_CREATE: 'FULL_TEXT_REVIEW_OUTCOME_CREATE',
  FULL_TEXT_REVIEW_OUTCOME_UPDATE: 'FULL_TEXT_REVIEW_OUTCOME_UPDATE',
  FULL_TEXT_REVIEW_OUTCOME_REVOKE: 'FULL_TEXT_REVIEW_OUTCOME_REVOKE',
  DATA_EXTRACTION_REPORT_PROPOSAL: 'DATA_EXTRACTION_REPORT_PROPOSAL',
  DATA_EXTRACTION_REPORT_ACCEPTED: 'DATA_EXTRACTION_REPORT_ACCEPTED',
  COMMENT_CREATE: 'COMMENT_CREATE',
  COMMENT_EDIT: 'COMMENT_EDIT',
  COMMENT_DELETE: 'COMMENT_DELETE',
  TAG_ADD: 'TAG_ADD',
  TAG_REMOVE: 'TAG_REMOVE',
  FULL_TEXT_PDF_UPLOAD: 'FULL_TEXT_PDF_UPLOAD',
  FULL_TEXT_PDF_UPDATE: 'FULL_TEXT_PDF_UPDATE',
  FULL_TEXT_PDF_DELETE: 'FULL_TEXT_PDF_DELETE',
  FULL_TEXT_PDF_FETCH_STARTED: 'FULL_TEXT_PDF_FETCH_STARTED',
  FULL_TEXT_PDF_FETCH_NOT_FOUND: 'FULL_TEXT_PDF_FETCH_NOT_FOUND',
  FULL_TEXT_PDF_FETCH_ERROR: 'FULL_TEXT_PDF_FETCH_ERROR',
});
